import {
  checkStatus,
  parseQueryString,
  getSourceFileFromEnv,
  getEnforcedEventsFileFromEnv,
  getEnforcedSourceFileFromEnv,
  getUpdateAddr
} from './functions'
import { getAccessToken } from './account'
import axios from 'axios'

const useS3Scheme = process.env.MEDIA_STORE_SCHEME === 's3'
const { audience } = parseQueryString()

const envs_modified = {
  host: process.env.MEDIA_STORE_HOST,
  bucket: process.env.MEDIA_STORE_MODIFIED_BUCKET
}

const envs = {
  host: process.env.MEDIA_STORE_HOST,
  bucket: process.env.MEDIA_STORE_ORIGIN_BUCKET
}

async function sign (bucket, set, object, headers) {
  const accessToken = await getAccessToken()

  return axios({
    url: `${process.env.MEDIA_STORE_HOST}/api/v1/backends/${process.env.MEDIA_STORE_HLS_BACKEND}/sign`,
    method: 'POST',
    data: {
      method: 'PUT',
      bucket,
      set,
      object,
      headers
    },
    headers: {
      'authorization': `Bearer ${accessToken}`,
      'content-type': 'application/json'
    }
  })
    .then(checkStatus)
}

// получение файла событий
export async function readEvents ({ metaUrl }) {
  const accessToken = await getAccessToken()

  return new Promise((resolve, reject) => {
    return axios({
      url: `${metaUrl}?access_token=${accessToken}`,
      method: 'GET'
    })
      .then(checkStatus)
      .then(response => resolve(response.data))
      .catch(err => reject(err.response))
  })
}

// сохранение измененного файла событий
export async function updateEvents ({ meta, mediaId }) {
  const headers = {
    'cache-control': 'no-cache',
    'content-encoding': 'gzip',
    'content-type': 'application/json'
  }
  const signResponse = await sign(envs_modified.bucket, mediaId, 'events.json', headers)

  return new Promise((resolve, reject) => {
    return axios({
      url: signResponse.data.uri,
      method: 'PUT',
      headers,
      data: meta
    })
      .then(checkStatus)
      .then(() => resolve())
      .catch(err => reject(err.response))
  })
}

// постановка задачи на транскодинг
export async function transcodeWebinarToHLS ({ mediaId, mediaUrl, preRollUrl, postRollUrl, thumbnailUrl, watermarkUrl }) {
  const accessToken = await getAccessToken()
  const getEventsFile = getEnforcedEventsFileFromEnv(envs_modified)
  const getSourceFile = getSourceFileFromEnv(envs)
  const getEnforcedSourceFile = getEnforcedSourceFileFromEnv(envs)

  return new Promise((resolve, reject) => {
    const url = getUpdateAddr(process.env.MEDIA_GW_HOST, audience, mediaId)
    const sourceUrl = useS3Scheme && getSourceFile(mediaId) === mediaUrl ? getEnforcedSourceFile(mediaId) : mediaUrl
    const metaUrl = getEventsFile(mediaId)
    const params = {
      template: 'transcode-webinar-to-hls',
      bindings: {
        webinar_id: mediaId,
        source: sourceUrl,
        events: metaUrl,
        client_webhook: process.env.MEDIA_TQ_CLIENT_WEBHOOK
      },
      priority: 'low'
    }

    if (preRollUrl) params.bindings.preroll = preRollUrl
    if (postRollUrl) params.bindings.postroll = postRollUrl
    if (thumbnailUrl) params.bindings.thumbnail = thumbnailUrl
    if (watermarkUrl) params.bindings.watermark = watermarkUrl

    return axios({
      url,
      method: 'POST',
      headers: {
        'authorization': `Bearer ${accessToken}`,
        'content-type': 'application/json'
      },
      data: params
    })
      .then(checkStatus)
      .then(() => resolve())
      .catch(err => reject(err.response))
  })
}

// постановка задачи на перемещение событий
export async function moveEvents ({ mediaId }) {
  const accessToken = await getAccessToken()
  const getEventsFile = getEnforcedEventsFileFromEnv(envs_modified)

  return new Promise((resolve, reject) => {
    const url = getUpdateAddr(process.env.MEDIA_GW_HOST, audience, mediaId)
    const metaUrl = getEventsFile(mediaId)
    const params = {
      template: 'move-webinar-events',
      bindings: {
        webinar_id: mediaId,
        events: metaUrl,
        initial_offset: 2.67 // pre-roll duration (hardcoded value)
      },
      priority: 'low'
    }

    return axios({
      url,
      method: 'POST',
      headers: {
        'authorization': `Bearer ${accessToken}`,
        'content-type': 'application/json'
      },
      data: params
    })
      .then(checkStatus)
      .then(() => resolve())
      .catch(err => reject(err.response))
  })
}

// загрузка файла в хранилище
export async function upload (set, object, file) {
  const headers = {
    'cache-control': 'max-age=31536000',
    'content-type': file.type
  }
  const signResponse = await sign(process.env.MEDIA_STORE_CONTENT_BUCKET, set, object, headers)

  return new Promise((resolve, reject) => {
    return axios({
      url: signResponse.data.uri,
      method: 'PUT',
      headers,
      data: file
    })
      .then(checkStatus)
      .then((response) => {
        resolve(response)
      })
      .catch(err => reject(err))
  })
}



// WEBPACK FOOTER //
// ./src/utils/api.js